import { render, staticRenderFns } from "./AboutChairman.vue?vue&type=template&id=ae027f96&"
import script from "./AboutChairman.vue?vue&type=script&lang=js&"
export * from "./AboutChairman.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports